import { Instagram, MessageCircle } from "lucide-react";
import { Reveal, Label } from "./primitives";
import { BRAND } from "../../config";
import logo from "../../assets/logo.png";

export const Contact = () => (
  <section
    id="contact"
    data-testid="contact-section"
    className="relative pt-24 md:pt-32 px-6 md:px-10 overflow-hidden"
  >
    <div className="aura w-[600px] h-[600px] -top-40 left-1/2 -translate-x-1/2" />
    <div className="max-w-[1000px] mx-auto text-center relative">
      <Reveal>
        <Label>Begin Your Journey</Label>
        <h2 className="mt-6 font-serif-display font-light text-5xl sm:text-7xl text-[#EAE0D5] tracking-tight leading-[0.95]">
          Let the cards <br />
          <span className="italic text-[#D4AF37]">speak to you.</span>
        </h2>
        <p className="mt-8 max-w-lg mx-auto text-[#A89FA8] leading-relaxed">
          Readings and healing sessions are booked directly through Instagram
          and WhatsApp. Reach out — I would love to hear from you.
        </p>
      </Reveal>

      <Reveal delay={0.15}>
        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={BRAND.instagram}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-instagram-btn"
            className="group flex items-center gap-3 rounded-full bg-[#D4AF37] text-[#07040D] px-8 py-4 text-xs tracking-[0.2em] uppercase hover:bg-[#F2D06B] transition-colors duration-300 w-full sm:w-auto justify-center"
          >
            <Instagram className="w-4 h-4" strokeWidth={1.8} />
            {BRAND.instagramHandle}
          </a>
          <a
            href={BRAND.whatsapp}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-whatsapp-btn"
            className="group flex items-center gap-3 rounded-full border border-[#D4AF37] text-[#D4AF37] px-8 py-4 text-xs tracking-[0.2em] uppercase hover:bg-[#D4AF37] hover:text-[#07040D] transition-colors duration-300 w-full sm:w-auto justify-center"
          >
            <MessageCircle className="w-4 h-4" strokeWidth={1.8} />
            {BRAND.whatsappLabel}
          </a>
        </div>
      </Reveal>
    </div>

    <footer className="mt-24 border-t border-[#2A1F3D] py-10 px-0">
      <div className="max-w-[1400px] mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <img
          src={logo}
          alt="Tarot Guidance by Ishita Dhar"
          width="554"
          height="160"
          loading="lazy"
          decoding="async"
          className="h-14 w-auto object-contain opacity-90"
        />
        <p className="text-xs tracking-[0.14em] uppercase text-[#756D7A]">
          © {new Date().getFullYear()} · Guided with love & light
        </p>
      </div>
    </footer>
  </section>
);
